import type { DiscountsSummary } from '~/types';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';

export function useSales() {
    const apiBasePath = `/v1`;
    const $_fetch = useCustomFetch();
    const useApiUtilsObj = useApiUtils();
    
    async function getDiscountsSummary(): Promise<DiscountsSummary | Error> {
        const url = `${apiBasePath}/pricing/`;

        try {
            const response = await $_fetch<DiscountsSummary>(url);
            return response;
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    return {
        getDiscountsSummary
    };
}
